import styled from 'styled-components';
import businessManImg from '~assets/business-man.jpg';
import { BANNER_SPACE_PERCENTAGE } from '../../constants';

export const Background = styled.aside`
  position: fixed;
  background: linear-gradient(to right, transparent 0%, #000 75%),
    url(${businessManImg}) no-repeat;
  background-size: cover;
  background-position: center;
  width: ${BANNER_SPACE_PERCENTAGE};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 56px;
  padding-top: 176px;
  height: 100%;
  right: 0;
  text-align: end;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: none;
  }
`;
